import React, { useEffect, useRef, useState } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import useUsersApi from "../api/useUsersApi";
import useAdminsApi from "../api/useAdminsApi";
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import { Avatar, Dialog } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { IoMdAdd } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import CommonLoader from "../components/loaders/CommonLoader";
import { toast } from "react-toastify";
import AddTicketDialog from "../components/modals/AddTicketDialog";
import useTicketApi from "../api/useTicketApi";
import useSubscriptionApi from "../api/useSubscriptionApi";
import usePlacesApi from "../api/usePlacesApi";
import PremiumLoader from "../components/loaders/PremiumLoader";
import DriverCarInfoTable from "../components/users/DriverCarInfoTable";
import dayjs from "dayjs";
import axios from "axios";
import SmartPagination from "../components/main/Pagination";
import { useAuth } from '../contexts/AuthContext';
import CallConfirmationDialog from "../components/modals/CallConfirmationDialog";
import WhatsAppConfirmationDialog from "../components/modals/WhatsAppConfirmationDialog";
import useRidesApi from '../api/useRidesApi';

const ViewUserProfile = () => {
    const { getUser, loading, verifyDocuments, editUserStatus, editVehicleSelectionBySuperAdmin, changeParentUser, makeCall, sendWhatsAppNotification, getUserActivityHistory, getWalletBalanceAndHistory, getDriverCallHistory, getAdminCallHistory } = useUsersApi();
    const { getAdmins } = useAdminsApi();
    const { addTicket, loading: ticketLoading } = useTicketApi();
    const { getSubscriptionPlans, buyPlanWithoutMoney, loading: plansLoading } = useSubscriptionApi();
    const { searchCities, addCity, deleteCity, loading: placesLoading } = usePlacesApi();
    const [modalOpen, setModalOpen] = useState(false);
    const [buyPlanModal, setBuyPlanModal] = useState(false);
    const [statusModal, setStatusModal] = useState(false);
    const [statusField, setStatusField] = useState(""); // "account_status" or "duty_status"
    const [statusLoading, setStatusLoading] = useState(false);
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState("");
    const [addCityModal, setAddCityModal] = useState(false);
    const [citySearchQuery, setCitySearchQuery] = useState("");
    const [citySearchResults, setCitySearchResults] = useState([]);
    const [selectedCityToAdd, setSelectedCityToAdd] = useState(null);
    const [addCityConfirmModal, setAddCityConfirmModal] = useState(false);
    const [cityDeleting, setCityDeleting] = useState(false);
    const [cityToDelete, setCityToDelete] = useState(null);
    const [deleteCityConfirmModal, setDeleteCityConfirmModal] = useState(false);
    const [citySearchPage, setCitySearchPage] = useState(1);
    const [totalCitySearchPages, setTotalCitySearchPages] = useState(1);
    const [selectedDoc, setSelectedDoc] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const mainSwiperRef = useRef(null);
    const [openApprove, setOpenApprove] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [openApproveCarDoc, setOpenApproveCarDoc] = useState(false);
    const [openRejectCarDoc, setOpenRejectCarDoc] = useState(false);
    const [reason, setReason] = useState("");
    const { id } = useParams();
    const [data, setData] = useState();
    const navigate = useNavigate();
    const [addTicketForm, setAddTicketForm] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [transactionLoading, setTransactionLoading] = useState(false);
    const [tickets, setTickets] = useState([]);
    const [ticketsLoading, setTicketsLoading] = useState(false);
    const [ticketPage, setTicketPage] = useState(1);
    const [totalTicketPages, setTotalTicketPages] = useState(1);
    const [ticketLimit] = useState(10);
    const [vehicleIds, setVehicleIds] = useState([]);
    const [vehicleLoading, setVehicleLoading] = useState(false);
    const [showAdminModal, setShowAdminModal] = useState(false);
    const [allAdmins, setAllAdmins] = useState([]);
    const [selectedAdminId, setSelectedAdminId] = useState("");
    const [updatingAdmin, setUpdatingAdmin] = useState(false);
    const baseApiUrl = process.env.REACT_APP_API_URL;
    const { isActionAllowed, profile } = useAuth();
    const [callDialogOpen, setCallDialogOpen] = useState(false);
    const [callLoading, setCallLoading] = useState(false);
    const [whatsappDialogOpen, setWhatsappDialogOpen] = useState(false);
    const [whatsappLoading, setWhatsappLoading] = useState(false);
    // ---- Rides tab ----
    const { getDriverRides, viewRide: viewRideDetail, getMyRides, rejectRide, loading: ridesApiLoading } = useRidesApi();
    const [rides, setRides] = useState([]);
    const [ridesLoading, setRidesLoading] = useState(false);
    const [ridePage, setRidePage] = useState(1);
    const [totalRidePages, setTotalRidePages] = useState(1);

    // ---- My Rides tab ----
    const [myRides, setMyRides] = useState([]);
    const [myRidesLoading, setMyRidesLoading] = useState(false);
    const [myRidePage, setMyRidePage] = useState(1);
    const [totalMyRidePages, setTotalMyRidePages] = useState(1);
    const [openRideView, setOpenRideView] = useState(false);
    const [selectedRideDetail, setSelectedRideDetail] = useState(null);
    const [rideDetailLoading, setRideDetailLoading] = useState(false);
    const [openCancelRide, setOpenCancelRide] = useState(false);
    const [selectedRideToCancel, setSelectedRideToCancel] = useState(null);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');
    const [selectedUserName, setSelectedUserName] = useState('');
    // -------------------
    console.log(vehicleIds)
    // ---- Activity tab ----
    const [activityLogs, setActivityLogs] = useState([]);
    const [activityLoading, setActivityLoading] = useState(false);
    const [activityPage, setActivityPage] = useState(1);
    const [totalActivityPages, setTotalActivityPages] = useState(1);
    const [activityStartDate, setActivityStartDate] = useState('');
    const [activityEndDate, setActivityEndDate] = useState('');
    const [activityLoaded, setActivityLoaded] = useState(false);
    const [activeTab, setActiveTab] = useState('pills-document');

    // ---- Wallet History tab ----
    const [walletBalance, setWalletBalance] = useState(null);
    const [walletHistory, setWalletHistory] = useState([]);
    const [walletLoading, setWalletLoading] = useState(false);
    const [walletPage, setWalletPage] = useState(1);
    const [totalWalletPages, setTotalWalletPages] = useState(1);
    const [walletLoaded, setWalletLoaded] = useState(false);

    // ---- Ride Call tab ----
    const [rideCalls, setRideCalls] = useState([]);
    const [rideCallLoading, setRideCallLoading] = useState(false);
    const [rideCallPage, setRideCallPage] = useState(1);
    const [totalRideCallPages, setTotalRideCallPages] = useState(1);
    const [rideCallLoaded, setRideCallLoaded] = useState(false);

    // ---- Call History tab ----
    const [callHistory, setCallHistory] = useState([]);
    const [callHistoryLoading, setCallHistoryLoading] = useState(false);
    const [callHistoryPage, setCallHistoryPage] = useState(1);
    const [totalCallHistoryPages, setTotalCallHistoryPages] = useState(1);
    const [callHistoryLoaded, setCallHistoryLoaded] = useState(false);
    const [playingAudio, setPlayingAudio] = useState(null);
    const [playingUrl, setPlayingUrl] = useState(null);
    const [isAudioPaused, setIsAudioPaused] = useState(false);

    const toApiStartDateTime = (isoDate) => isoDate ? dayjs(isoDate).startOf('day').toISOString() : '';
    const toApiEndDateTime = (isoDate) => isoDate ? dayjs(isoDate).endOf('day').toISOString() : '';

    const fetchWalletHistory = async (page = 1) => {
        if (!id) return;
        try {
            setWalletLoading(true);
            const res = await getWalletBalanceAndHistory(id, page, 10);
            const payload = res?.data?.payload;
            setWalletBalance(payload?.wallet || null);
            setWalletHistory(payload?.wallet_history || []);
            setTotalWalletPages(payload?.total_pages || 1);
            setWalletLoaded(true);
        } catch (err) {
            // handled by useApi
        } finally {
            setWalletLoading(false);
        }
    };

    const fetchRideCallHistory = async (page = 1) => {
        if (!id) return;
        try {
            setRideCallLoading(true);
            const res = await getDriverCallHistory(id, page, 10);
            const payload = res?.data?.payload;
            setRideCalls(payload?.call_history || []);
            setTotalRideCallPages(payload?.total_pages || 1);
            setRideCallLoaded(true);
        } catch (err) {
            // handled by useApi
        } finally {
            setRideCallLoading(false);
        }
    };

    const fetchCallHistory = async (page = 1) => {
        if (!id) return;
        try {
            setCallHistoryLoading(true);
            const res = await getAdminCallHistory(id, page, 10);
            const payload = res?.data?.payload;
            setCallHistory(payload?.call_history || []);
            setTotalCallHistoryPages(payload?.total_pages || 1);
            setCallHistoryLoaded(true);
        } catch (err) {
            // handled by useApi
        } finally {
            setCallHistoryLoading(false);
        }
    };

    const handlePlayAudio = (url) => {
        if (playingAudio && playingUrl === url) {
            // Toggle pause/resume for same track
            if (playingAudio.paused) {
                playingAudio.play();
                setIsAudioPaused(false);
            } else {
                playingAudio.pause();
                setIsAudioPaused(true);
            }
        } else {
            // Stop current, play new
            if (playingAudio) {
                playingAudio.pause();
                playingAudio.currentTime = 0;
            }
            const audio = new Audio(url);
            audio.play();
            audio.onplay = () => setIsAudioPaused(false);
            audio.onpause = () => setIsAudioPaused(true);
            setPlayingAudio(audio);
            setPlayingUrl(url);
            setIsAudioPaused(false);
            audio.onended = () => { setPlayingAudio(null); setPlayingUrl(null); setIsAudioPaused(false); };
        }
    };

    const fetchActivity = async (page = 1, startDate = activityStartDate, endDate = activityEndDate) => {
        if (!id) return;
        try {
            setActivityLoading(true);
            const res = await getUserActivityHistory(id, page, 10, toApiStartDateTime(startDate), toApiEndDateTime(endDate));
            const payload = res?.data?.payload;
            setActivityLogs(payload?.usage_history || payload?.list || payload?.activity_logs || payload?.data || []);
            setTotalActivityPages(payload?.total_pages || 1);
            setActivityLoaded(true);
        } catch (err) {
            // handled by useApi
        } finally {
            setActivityLoading(false);
        }
    };
    // ----------------------
    // ---- Ride helpers ----
    const fetchDriverRides = async (page = 1) => {
        if (!id) return;
        try {
            setRidesLoading(true);
            const res = await getDriverRides(id, page, 10);
            const payload = res?.data?.payload;
            setRides(payload?.all_bookings || payload?.bookings || []);
            setTotalRidePages(payload?.total_pages || 1);
        } catch (err) {
            // handled by useApi
        } finally {
            setRidesLoading(false);
        }
    };

    const fetchMyCreatedRides = async (page = 1) => {
        if (!id) return;
        try {
            setMyRidesLoading(true);
            const res = await getMyRides(id, page, 10);
            const payload = res?.data?.payload;
            setMyRides(payload?.all_bookings || payload?.bookings || []);
            setTotalMyRidePages(payload?.total_pages || 1);
        } catch (err) {
            // handled by useApi
        } finally {
            setMyRidesLoading(false);
        }
    };

    const handleViewRide = async (booking) => {
        setSelectedRideDetail(null);
        setOpenRideView(true);
        try {
            setRideDetailLoading(true);
            const res = await viewRideDetail(booking._id);
            setSelectedRideDetail(res?.data?.payload?.booking_object || booking);
        } catch (err) {
            setSelectedRideDetail(booking);
        } finally {
            setRideDetailLoading(false);
        }
    };

    const handleOpenCancelRide = (ride) => {
        setSelectedRideToCancel(ride);
        setReason("");
        setOpenCancelRide(true);
    };

    const handleWhatsAppClick = (phoneNumber, userName) => {
        setSelectedPhoneNumber(phoneNumber);
        setSelectedUserName(userName);
        setWhatsappDialogOpen(true);
    };

    const showPhone = (phoneNumber, userName) => {
        setSelectedPhoneNumber(phoneNumber);
        setSelectedUserName(userName);
        setCallDialogOpen(true);
    };

    const handleCancelRide = async (e) => {
        e.preventDefault();
        const payload = {
            "booking_id": selectedRideToCancel._id,
            "closed_reason": reason
        }
        await rejectRide(payload);
        setOpenCancelRide(false);
        setReason("");
        toast.success("Ride Closed");
        fetchMyCreatedRides(myRidePage);
    };

    const rideStatusBadge = (status) => {
        const map = {
            '0': { text: 'Pending', cls: 'bg-warning-focus text-warning-600 border border-warning-main' },
            '1': { text: 'Accepted', cls: 'bg-info-focus text-info-600 border border-info-main' },
            '2': { text: 'Confirmed', cls: 'bg-primary-focus text-primary-600 border border-primary-main' },
            '3': { text: 'Completed', cls: 'bg-success-focus text-success-600 border border-success-main' },
            '4': { text: 'Cancelled', cls: 'bg-danger text-white border border-danger' },
            '5': { text: 'Closed', cls: 'bg-secondary text-white border border-secondary-main' },
        };
        const s = map[String(status)] || { text: 'Unknown', cls: 'bg-gray-200 text-gray-600 border border-gray-400' };
        return <span className={`${s.cls} px-24 py-4 radius-4 fw-medium text-sm`}>{s.text}</span>;
    };
    // ----------------------
    const handleThumbnailClick = (index) => {
        setActiveIndex(index);
        if (mainSwiperRef.current) {
            mainSwiperRef.current.swiper.slideTo(index);
        }
    };

    const openModal = (details) => {
        setSelectedDoc(details);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleApprove = (docInfo) => {
        setSelectedDoc(docInfo);
        setOpenApprove(true)
    };

    const handleReject = (docInfo) => {
        setReason("")
        setSelectedDoc(docInfo);
        setOpenReject(true)
    };

    const handleApproveCarDoc = (docInfo) => {
        setSelectedDoc(docInfo);
        setOpenApproveCarDoc(true)
    };

    const handleRejectCarDoc = (docInfo) => {
        setReason("")
        setSelectedDoc(docInfo);
        setOpenRejectCarDoc(true)
    };

    async function getDetails() {
        const res = await getUser(id);
        console.log(res.data?.payload)
        setData(res.data?.payload?.cabzzy_user)
        setTransactions(res.data?.payload?.cabzzy_user?.transactions || [])
    }

    useEffect(() => {
        getDetails()
    }, [])

    const renderStars = (rating) => {
        let stars = [];
        for (let i = 1; i <= 5; i++) {
            if (rating >= i) {
                stars.push(<FaStar key={i} className="text-warning" />);
            } else if (rating >= i - 0.5) {
                stars.push(<FaStarHalfAlt key={i} className="text-warning" />);
            } else {
                stars.push(<FaRegStar key={i} className="text-warning" />);
            }
        }
        return stars;
    };

    const handleApproveSubmit = async () => {
        setOpenApprove(false);
        const payload = {
            "documentId": selectedDoc._id,
            "documentType": selectedDoc.docType, //valid("aadhaarcard_info","driver_license_info","driver_car_info","other_docs")
            "document_status": "2", // 0:pendding, 1: review, 2: verified,3:unverified
        }
        await verifyDocuments(payload);
        getDetails()
    };

    const handleRejectSubmit = async () => {
        if (!reason.trim()) {
            toast.error("Please enter a rejection reason.");
            return;
        }
        const payload = {
            "documentId": selectedDoc._id,
            "documentType": selectedDoc.docType, //valid("aadhaarcard_info","driver_license_info","driver_car_info","other_docs")
            "document_status": "3", // 0:pendding, 1: review, 2: verified,3:unverified
            "reason": reason //if pass 3 in status then this field required
        }
        setOpenReject(false);
        await verifyDocuments(payload);
        getDetails()
    };
    const handleApproveSubmitCarDoc = async () => {
        setOpenApprove(false);
        const payload = {
            "documentId": selectedDoc._id,
            "documentType": "driver_car_info", //valid("aadhaarcard_info","driver_license_info","driver_car_info","other_docs")
            "document_status": "2", // 0:pendding, 1: review, 2: verified,3:unverified
        }
        setOpenApproveCarDoc(false)
        await verifyDocuments(payload);
        getDetails()
    };

    const handleRejectSubmitCarDoc = async () => {
        if (!reason.trim()) {
            toast.error("Please enter a rejection reason.");
            return;
        }
        const payload = {
            "documentId": selectedDoc._id,
            "documentType": "driver_car_info", //valid("aadhaarcard_info","driver_license_info","driver_car_info","other_docs")
            "document_status": "3", // 0:pendding, 1: review, 2: verified,3:unverified
            "reason": reason //if pass 3 in status then this field required
        }
        setOpenReject(false);
        setOpenRejectCarDoc(false)
        await verifyDocuments(payload);
        getDetails()
    };

    useEffect(() => {
        if (data?.driver_vehicle_history) {
            const selected = data.driver_vehicle_history
                .filter(v => v.is_selected === true)
                .map(v => v._id);
            setVehicleIds(selected);
        }
    }, [data]);

    const handleVehicleToggle = async (vehicleId) => {
        // if (profile?.user_type !== 'superadmin') return;

        let newSelected = [...vehicleIds];
        if (newSelected.includes(vehicleId)) {
            newSelected = newSelected.filter(id => id !== vehicleId);
        } else {
            newSelected.push(vehicleId);
        }

        setVehicleIds(newSelected);
        setVehicleLoading(true);
        try {
            await editVehicleSelectionBySuperAdmin({
                vehicle_ids: newSelected,
                user_id: id
            });
            toast.success("Vehicle selection updated successfully");
            getDetails();
        } catch (error) {
            console.error(error);
            toast.error("Failed to update vehicle selection");
        } finally {
            setVehicleLoading(false);
        }
    };

    const fetchAdmins = async () => {
        try {
            const res = await getAdmins(1, "");
            setAllAdmins(res?.data?.payload?.all_imp_users || []);
        } catch (error) {
            console.error("Error fetching admins:", error);
        }
    };

    const handleChangeAdmin = async () => {
        if (!selectedAdminId) {
            toast.error("Please select an admin");
            return;
        }
        setUpdatingAdmin(true);
        try {
            await changeParentUser({
                user_id: id,
                parent_user_id: selectedAdminId
            });
            toast.success("Admin updated successfully");
            setShowAdminModal(false);
            getDetails();
        } catch (error) {
            console.error("Error updating admin:", error);
            toast.error("Failed to update admin");
        } finally {
            setUpdatingAdmin(false);
        }
    };

    const handleCallConfirm = async () => {
        try {
            setCallLoading(true);
            await makeCall(selectedPhoneNumber || data?.phone_number);
            toast.success('Call initiated successfully!');
        } catch (err) {
            // error handled by useApi hook
        } finally {
            setCallLoading(false);
            setCallDialogOpen(false);
            setSelectedPhoneNumber('');
            setSelectedUserName('');
        }
    };

    const handleWhatsAppConfirm = async () => {
        try {
            setWhatsappLoading(true);
            await sendWhatsAppNotification(selectedPhoneNumber || data?.phone_number);
            toast.success('WhatsApp notification sent successfully!');
        } catch (err) {
            // error handled by useApi hook
        } finally {
            setWhatsappLoading(false);
            setWhatsappDialogOpen(false);
            setSelectedPhoneNumber('');
            setSelectedUserName('');
        }
    };

    const handleAddTicket = async (payload) => {
        await addTicket({
            "user_id": id,
            "title": payload?.title,
            "description": payload?.description,
            "date": payload?.date
        });
        setAddTicketForm(false);
        toast.success("Ticket Added Successfully!");
    }

    const fetchPlans = async () => {
        try {
            const res = await getSubscriptionPlans();
            setPlans(res.data?.payload?.subscription_plan || []);
        } catch (error) {
            console.error("Error fetching plans:", error);
        }
    }

    const handleBuyPlan = async () => {
        if (!selectedPlan) {
            toast.error("Please select a plan");
            return;
        }
        try {
            const payload = {
                plan_id: selectedPlan,
                user_id: id
            };
            const res = await buyPlanWithoutMoney(payload);
            if (res.status === 200 || res.status === 201) {
                toast.success("Plan assigned successfully!");
                setBuyPlanModal(false);
                setSelectedPlan("");
                getDetails();
            }
        } catch (error) {
            console.error("Error buying plan:", error);
        }
    }

    const handleToggleStatus = async () => {
        try {
            setStatusLoading(true);
            const payload = {
                user_id: id,
                field_value: statusField
            };
            const res = await editUserStatus(payload);
            if (res.status === 200 || res.status === 201) {
                toast.success(`${statusField === "account_status" ? "Account" : "Duty"} status updated successfully!`);
                setStatusModal(false);
                getDetails();
            }
        } catch (error) {
            console.error("Error toggling status:", error);
        } finally {
            setStatusLoading(false);
        }
    }

    const openStatusToggle = (field) => {
        setStatusField(field);
        setStatusModal(true);
    }

    const handleSearchCities = async (query, page = 1) => {
        if (!query) {
            setCitySearchResults([]);
            setTotalCitySearchPages(1);
            return;
        }
        try {
            const res = await searchCities(query, page);
            const newPlaces = res.data?.payload?.placesData || [];
            if (page === 1) {
                setCitySearchResults(newPlaces);
            } else {
                setCitySearchResults(prev => [...prev, ...newPlaces]);
            }
            setTotalCitySearchPages(res.data?.payload?.total_pages || 1);
            setCitySearchPage(res.data?.payload?.current_page || page);
        } catch (error) {
            console.error("Error searching cities:", error);
        }
    }

    const handleAddCity = async () => {
        if (!selectedCityToAdd || !data?.x_auth_token) return;
        try {
            const payload = {
                city_name: selectedCityToAdd.city_name,
                state_name: selectedCityToAdd.state_name,
                country_name: selectedCityToAdd.country_name,
                lat: selectedCityToAdd.lat.toString(),
                lng: selectedCityToAdd.lng.toString(),
                pincode: selectedCityToAdd.pincode || "",
                user_id: id
            };
            const res = await addCity(payload, data.x_auth_token);
            if (res.status === 200 || res.status === 201) {
                toast.success("City added successfully!");
                setAddCityConfirmModal(false);
                setAddCityModal(false);
                setCitySearchQuery("");
                setCitySearchResults([]);
                getDetails();
            }
        } catch (error) {
            console.error("Error adding city:", error);
        }
    }

    const handleDeleteCity = async () => {
        if (!cityToDelete || !data?.x_auth_token) return;
        try {
            setCityDeleting(true);
            const res = await deleteCity(cityToDelete._id, data.x_auth_token);
            if (res.status === 200 || res.status === 201) {
                toast.success("City removed successfully!");
                setDeleteCityConfirmModal(false);
                setCityToDelete(null);
                getDetails();
            }
        } catch (error) {
            console.error("Error deleting city:", error);
        } finally {
            setCityDeleting(false);
        }
    }

    useEffect(() => {
        const delaySearch = setTimeout(() => {
            if (citySearchQuery) {
                setCitySearchPage(1);
                handleSearchCities(citySearchQuery, 1);
            }
        }, 500);
        return () => clearTimeout(delaySearch);
    }, [citySearchQuery]);

    useEffect(() => {
        if (buyPlanModal) {
            fetchPlans();
        }
    }, [buyPlanModal]);

    // Add function to fetch transaction history
    const fetchTransactionHistory = async () => {
        // try {
        //     setTransactionLoading(true);
        //     const response = await axios.get(`${baseApiUrl}/user/wallet/get_history`, {
        //         headers: {
        //             'x-auth-token': data.x_auth_token
        //         }
        //     });
        //     setTransactions(response.data?.payload.transactions  || []);
        // } catch (error) {
        //     console.error('Error fetching transactions:', error);
        //     toast.error('Failed to fetch transaction history');
        // } finally {
        //     setTransactionLoading(false);
        // }
    };

    // Modify fetch tickets function to handle pagination
    const fetchTickets = async (page = 1) => {
        try {
            setTicketsLoading(true);
            const authToken = localStorage.getItem('authToken');
            const response = await axios.get(`${baseApiUrl}/imp/tickets_screen/get_ticket_by_userId?page=${page}&limit=${ticketLimit}&user_id=${id}`, {
                headers: {
                    Authorization: authToken ? `Bearer ${authToken}` : '',
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true',
                },
            });
            setTickets(response.data?.payload?.tickets || []);
            setTotalTicketPages(Math.ceil((response.data?.payload?.total_pages || 0) / ticketLimit));
        } catch (error) {
            console.error('Error fetching tickets:', error);
            toast.error('Failed to fetch tickets');
        } finally {
            setTicketsLoading(false);
        }
    };

    const handleTicketPageChange = (newPage) => {
        setTicketPage(newPage);
        fetchTickets(newPage);
    };

    useEffect(() => {
        if (data?.x_auth_token) {
            fetchTransactionHistory();
        }
    }, [data?.x_auth_token]);

    useEffect(() => {
        fetchTickets(1);
    }, []);

    return (<>
        <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
            <div className="d-flex align-items-center justify-content-start  gap-3">
                <IoArrowBackOutline
                    size={22}
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate('/users-list')}
                />
                <h6 className='fw-semibold mb-0'>User Profile</h6>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3">
                {isActionAllowed('Subscription', 'create') ? (
                    <button onClick={() => setBuyPlanModal(true)} className="btn btn-warning d-flex align-items-center justify-content-center gap-1">
                        <Icon icon="mdi:cart-plus" size={20} />
                        Buy Plan
                    </button>
                ) : null}
                {isActionAllowed('Tickets', 'create') ? (
                    <button onClick={() => setAddTicketForm(true)} className="btn btn-primary d-flex align-items-center justify-content-center gap-1"><IoMdAdd size={20} />
                        Add Ticket</button>
                ) : null}
            </div>
        </div>

        {loading ? (
            <CommonLoader />) :
            <div className="row gy-4">
                {/* Left: Profile */}
                <div className="col-lg-4">
                    <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                        {data?.is_live ? (
                            <span
                                className="bg-success-focus text-success-600 border border-success-main px-24 py-4 fw-medium text-sm cursor-pointer"
                                style={{ borderTopLeftRadius: "20px", borderBottomRightRadius: "20px" }}
                                onClick={() => openStatusToggle("account_status")}
                            >
                                Active
                            </span>
                        ) : (
                            <span
                                className="bg-danger text-white border border-danger px-24 py-4 radius-4 fw-medium text-sm cursor-pointer"
                                onClick={() => openStatusToggle("account_status")}
                            >
                                Inactive
                            </span>
                        )}
                        <img
                            src="assets/images/user-grid/user-grid-bg1.png"
                            alt=""
                            className="w-100 object-fit-cover"
                        />
                        <div className="pb-24 ms-16 mb-24 me-16 mt-100">
                            <div className="text-center border border-top-0 border-start-0 border-end-0 d-flex flex-column align-items-center justify-content-center ">
                                <Avatar
                                    src={data?.profile_photo}
                                    alt=""
                                    className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                                />
                                <h6 className="mb-0 mt-16">{data?.user_name || '-'}</h6>
                                <span className="text-secondary-light mb-16">
                                    {data?.email || '-'}
                                </span>
                            </div>
                            <div className="mt-24">
                                <h6 className="text-xl mb-16">Personal Info</h6>
                                <ul>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Admin Name
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium d-flex align-items-center justify-content-between">
                                            {data?.parent_user_id?.user_name || '-'}
                                            {isActionAllowed('Admins', 'edit') && (
                                                <button
                                                    onClick={() => {
                                                        fetchAdmins();
                                                        setSelectedAdminId(data?.parent_user_id?._id || "");
                                                        setShowAdminModal(true);
                                                    }}
                                                    className="btn btn-sm btn-outline-primary p-1 d-flex align-items-center justify-content-center ms-2"
                                                    title="Change Admin"
                                                >
                                                    <Icon icon="lucide:edit" width={14} />
                                                </button>
                                            )}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Email
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.email || '-'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Phone Number
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium d-flex align-items-center gap-2">
                                            {data?.phone_number || '-'}
                                            <button
                                                onClick={() => showPhone(data?.phone_number, data?.user_name)}
                                                title="Call"
                                                className="btn btn-sm bg-success-focus text-success-600 p-1 d-flex align-items-center justify-content-center ms-2 radius-8"
                                            >
                                                <Icon icon="akar-icons:phone" width={16} />
                                            </button>
                                            <button
                                                onClick={() => handleWhatsAppClick(data?.phone_number, data?.user_name)}
                                                title="WhatsApp"
                                                className="btn btn-sm bg-info-focus text-info-600 p-1 d-flex align-items-center justify-content-center ms-2 radius-8"
                                            >
                                                <Icon icon="ic:baseline-whatsapp" width={16} />
                                            </button>
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Wallet Balance
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.wallet_balance || '0'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Subscription Days
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.subscription_days || '0'} {/* Assuming 'subscription_days' is the correct field */}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Subscription Repeat
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.subscription_repeat_count || '0'} {/* Assuming 'subscription_days' is the correct field */}
                                        </span>
                                    </li>
                                    {/* <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Traveler Name
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.trawellerName || '-'}
                                        </span>
                                    </li> */}
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Current Location
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.current_location?.city_name || ''}{", "}{data?.current_location?.state_name}{", "}{data?.current_location?.country_name || ''} {data?.current_location?.pinCode || ''}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Last Screen
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.current_application_screen?.screen_name || '-'}
                                            {data?.current_application_screen?.updated_at && (
                                                <span className="text-xs text-muted d-block mt-2">
                                                    Updated: {dayjs(data.current_application_screen.updated_at).format('DD MMM YYYY, hh:mm A')}
                                                </span>
                                            )}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Duty Status
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.duty_status === 1 ? (
                                                <span
                                                    className="badge bg-success cursor-pointer"
                                                    onClick={() => openStatusToggle("duty_status")}
                                                >
                                                    Online
                                                </span>
                                            ) : (
                                                <span
                                                    className="badge bg-danger cursor-pointer"
                                                    onClick={() => openStatusToggle("duty_status")}
                                                >
                                                    Offline
                                                </span>
                                            )}
                                        </span>
                                    </li>

                                    {/* <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Rating
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            <div className="d-flex gap-1">
                                                {renderStars(data?.ratings || 0)}
                                            </div>
                                        </span>
                                    </li> */}
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            User Mode
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            <div className="d-flex gap-1">
                                                {data?.user_mode || ''}
                                            </div>
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Registration Date
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {dayjs(data?.joining_day).format('DD-MM-YYYY hh:mm A') || '-'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Last Login
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {dayjs(data?.last_login).format('DD-MM-YYYY hh:mm A') || '-'}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Last Activity
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {
                                                dayjs(data?.last_activity?.last_active_at).isValid()
                                                    ? dayjs(data?.last_activity?.last_active_at).format('DD-MM-YYYY hh:mm A')
                                                    : '-'
                                            }                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            Subscription End Date
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {data?.subscription_exp ? dayjs(data?.subscription_exp).format('DD-MM-YYYY hh:mm A') : '-'}
                                        </span>
                                    </li>
                                </ul>



                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        Aadhar Card Status
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        {data?.all_documents?.aadhaarcard_info?.document_status === 0 ? (
                                            <span className="badge bg-white text-dark">Pending</span>
                                        ) : data?.all_documents?.aadhaarcard_info?.document_status === 1 ? (
                                            <span className="badge bg-warning text-dark">In Review</span>
                                        ) : data?.all_documents?.aadhaarcard_info?.document_status === 2 ? (
                                            <span className="badge bg-success">Verified</span>
                                        ) : data?.all_documents?.aadhaarcard_info?.document_status === 3 ? (
                                            <span className="badge bg-danger">Rejected</span>
                                        ) : null}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        Selected Language
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        {data?.selected_language || '-'}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        OTP
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        {data?.otp?.otp || '-'}
                                    </span>
                                </li>
                                {/* Cab Type Selection Section */}
                                {data?.driver_vehicle_history && data.driver_vehicle_history.length > 0 && (
                                    <div className="mt-24">
                                        <h6 className="text-xl mb-16">Cab Type Selection</h6>
                                        <div className="d-flex flex-wrap gap-3">
                                            {data.driver_vehicle_history.map((vehicle) => (
                                                <div key={vehicle._id} className="d-flex align-items-center gap-2 bg-base border radius-8 px-16 py-8">
                                                    <div className="form-check p-0 m-0">
                                                        <input
                                                            className="form-check-input ms-0"
                                                            type="checkbox"
                                                            id={`vehicle-${vehicle._id}`}
                                                            checked={vehicleIds.includes(vehicle._id)}
                                                            onChange={() => handleVehicleToggle(vehicle._id)}
                                                            disabled={vehicleLoading}
                                                        />
                                                    </div>
                                                    <label className="form-check-label text-md fw-medium text-secondary-light mb-0 cursor-pointer" htmlFor={`vehicle-${vehicle._id}`}>
                                                        {vehicle.vehicle_id?.name || 'Unknown'}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {vehicleLoading && <div className="text-secondary-light text-sm mt-1">Updating...</div>}
                                    </div>
                                )}
                                {/* Selected Cities Section */}
                                <div className="mt-24">
                                    <div className="d-flex justify-content-between align-items-center mb-16">
                                        <h6 className="text-xl mb-0">Selected Cities</h6>
                                        <button
                                            type="button"
                                            className="btn btn-primary d-flex align-items-center gap-2 py-8 px-16 radius-8"
                                            onClick={() => setAddCityModal(true)}
                                        >
                                            <IoMdAdd size={20} />
                                            Add City
                                        </button>
                                    </div>
                                    {data?.selected_cities && data.selected_cities.length > 0 ? (
                                        <div className="border rounded p-3">
                                            {data.selected_cities.map((city, index) => (
                                                <div key={city._id || index} className="position-relative">
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="d-flex justify-content-between">
                                                            <span className="text-md fw-semibold text-primary-light">City Name</span>
                                                            <span className="text-secondary-light fw-medium">{city.city_name}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="text-md fw-semibold text-primary-light">State Name</span>
                                                            <span className="text-secondary-light fw-medium">{city.state_name}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="text-md fw-semibold text-primary-light">Country Name</span>
                                                            <span className="text-secondary-light fw-medium">{city.country_name}</span>
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger  top-0 end-0 p-1 d-flex justify-content-end mt-3 align-items-center"
                                                        onClick={() => {
                                                            setCityToDelete(city);
                                                            setDeleteCityConfirmModal(true);
                                                        }}
                                                    >
                                                        <Icon icon="mdi:trash-can-outline" width={18} /> Delete
                                                    </button>
                                                    {index < data.selected_cities.length - 1 && <hr className="my-3" />}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-muted">No cities selected</p>
                                    )}
                                </div>
                                {/* <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        License Status
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        {data?.all_documents?.driver_license_info?.document_status === 0 ? (
                                            <span className="badge bg-white text-dark">Pending</span>
                                        ) : data?.all_documents?.driver_license_info?.document_status === 1 ? (
                                            <span className="badge bg-warning text-dark">In Review</span>
                                        ) : data?.all_documents?.driver_license_info?.document_status === 2 ? (
                                            <span className="badge bg-success">Verified</span>
                                        ) : data?.all_documents?.driver_license_info?.document_status === 3 ? (
                                            <span className="badge bg-danger">Rejected</span>
                                        ) : null}
                                    </span>
                                </li>

                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        Car Status
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        {data?.driver_car_info?.document_status === 0 ? (
                                            <span className="badge bg-white text-dark">Pending</span>
                                        ) : data?.driver_car_info?.document_status === 1 ? (
                                            <span className="badge bg-warning text-dark">In Review</span>
                                        ) : data?.driver_car_info?.document_status === 2 ? (
                                            <span className="badge bg-success">Verified</span>
                                        ) : data?.driver_car_info?.document_status === 3 ? (
                                            <span className="badge bg-danger">Rejected</span>
                                        ) : null}
                                    </span>
                                </li> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right: Documents */}
                <div className="col-lg-8">
                    <div className="card h-100">
                        <div className="card-body p-24">
                            <ul className="nav border-gradient-tab nav-pills mb-20 d-inline-flex">
                                {/* <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24 active"
                                        id="pills-bankdetails-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-bankdetails"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-bankdetails"
                                        aria-selected="true"
                                    >
                                        Bank Details
                                    </button>
                                </li> */}
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-document' ? 'active' : ''}`}
                                        id="pills-document-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-document"
                                        aria-selected={activeTab === 'pills-document'}
                                        onClick={() => setActiveTab('pills-document')}
                                    >
                                        Documents
                                    </button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24"
                                        id="pills-vehicles-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-vehicles"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-vehicles"
                                        aria-selected="true"
                                    >
                                        Driver Car Info
                                    </button>
                                </li> */}
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-transactions' ? 'active' : ''}`}
                                        id="pills-transactions-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-transactions"
                                        aria-selected={activeTab === 'pills-transactions'}
                                        onClick={() => setActiveTab('pills-transactions')}
                                    >
                                        Transactions
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-tickets' ? 'active' : ''}`}
                                        id="pills-tickets-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-tickets"
                                        aria-selected={activeTab === 'pills-tickets'}
                                        onClick={() => setActiveTab('pills-tickets')}
                                    >
                                        Tickets
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-rides' ? 'active' : ''}`}
                                        id="pills-rides-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-rides"
                                        aria-selected={activeTab === 'pills-rides'}
                                        onClick={() => {
                                            setActiveTab('pills-rides');
                                            if (rides.length === 0) fetchDriverRides(1);
                                        }}
                                    >
                                        Rides
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-my-rides' ? 'active' : ''}`}
                                        id="pills-my-rides-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-my-rides"
                                        aria-selected={activeTab === 'pills-my-rides'}
                                        onClick={() => {
                                            setActiveTab('pills-my-rides');
                                            if (myRides.length === 0) fetchMyCreatedRides(1);
                                        }}
                                    >
                                        My Rides
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-activity' ? 'active' : ''}`}
                                        id="pills-activity-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-activity"
                                        aria-selected={activeTab === 'pills-activity'}
                                        onClick={() => {
                                            setActiveTab('pills-activity');
                                            if (!activityLoaded) fetchActivity(1);
                                        }}
                                    >
                                        Activity
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-wallet' ? 'active' : ''}`}
                                        id="pills-wallet-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-wallet"
                                        aria-selected={activeTab === 'pills-wallet'}
                                        onClick={() => {
                                            setActiveTab('pills-wallet');
                                            if (!walletLoaded) fetchWalletHistory(1);
                                        }}
                                    >
                                        Wallet History
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-permissions' ? 'active' : ''}`}
                                        id="pills-permissions-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-permissions"
                                        aria-selected={activeTab === 'pills-permissions'}
                                        onClick={() => setActiveTab('pills-permissions')}
                                    >
                                        Permissions
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-device' ? 'active' : ''}`}
                                        id="pills-device-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-device"
                                        aria-selected={activeTab === 'pills-device'}
                                        onClick={() => setActiveTab('pills-device')}
                                    >
                                        Device Info
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-ridecall' ? 'active' : ''}`}
                                        id="pills-ridecall-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-ridecall"
                                        aria-selected={activeTab === 'pills-ridecall'}
                                        onClick={() => {
                                            setActiveTab('pills-ridecall');
                                            if (!rideCallLoaded) fetchRideCallHistory(1);
                                        }}
                                    >
                                        Ride Call
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link d-flex align-items-center px-24 ${activeTab === 'pills-callhistory' ? 'active' : ''}`}
                                        id="pills-callhistory-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-callhistory"
                                        aria-selected={activeTab === 'pills-callhistory'}
                                        onClick={() => {
                                            setActiveTab('pills-callhistory');
                                            if (!callHistoryLoaded) fetchCallHistory(1);
                                        }}
                                    >
                                        Call History
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                {/* <div
                                    className="tab-pane fade show active"
                                    id="pills-bankdetails"
                                    role="tabpanel"
                                    aria-labelledby="pills-bankdetails-tab"
                                    tabIndex={0}
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card shadow-sm p-24">
                                                <div className="d-flex flex-column gap-3">
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-semibold text-primary-light">Account Holder Name</span>
                                                        <span className="fw-medium text-secondary-light">{data?.bankDetails?.accountHolderName || '-'}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-semibold text-primary-light">Account Number</span>
                                                        <span className="fw-medium text-secondary-light">{data?.bankDetails?.accountNumber || '-'}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-semibold text-primary-light">IFSC Code</span>
                                                        <span className="fw-medium text-secondary-light">{data?.bankDetails?.ifscCode || '-'}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-semibold text-primary-light">UPI Id</span>
                                                        <span className="fw-medium text-secondary-light">{data?.upiId || '-'}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div
                                    className={`tab-pane fade card ${activeTab === 'pills-document' ? 'show active' : ''}`}
                                    id="pills-document"
                                    role="tabpanel"
                                    aria-labelledby="pills-document-tab"
                                    tabIndex={0}
                                >
                                    {data?.all_documents && Object.entries(data?.all_documents).filter(([_, doc]) => doc?.images?.length > 0).length > 0 === 0 ? (
                                        <p>No documents available.</p>
                                    ) : (
                                        <div className="card-body">
                                            <div className="table-responsive scroll-sm">
                                                <table className="table bordered-table sm-table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Number</th>
                                                            <th>Front Photo</th>
                                                            <th>Back Photo</th>
                                                            <th>Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data?.all_documents && Object.entries(data?.all_documents).filter(([_, doc]) => doc?.front_photo || doc?.back_photo).length > 0 ? (
                                                            Object.entries(data.all_documents).map(([docType, docInfo]) => (
                                                                (docInfo?.front_photo || docInfo?.back_photo) && (
                                                                    <tr key={docType}>
                                                                        <td>
                                                                            {docType.replace("Info", "").replace(/([A-Z])/g, " $1").trim().replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                                                                        </td>
                                                                        <td>{docInfo.number || docInfo.details}</td>
                                                                        <td>
                                                                            {docInfo.front_photo ? (
                                                                                <button
                                                                                    className="btn btn-sm btn-light"
                                                                                    onClick={() => openModal({ ...docInfo, images: [docInfo.front_photo] })}
                                                                                    title="View Front Photo"
                                                                                >
                                                                                    <Icon icon="mdi:eye" width={20} />
                                                                                </button>
                                                                            ) : (
                                                                                <span className="text-muted">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {docInfo.back_photo ? (
                                                                                <button
                                                                                    className="btn btn-sm btn-light"
                                                                                    onClick={() => openModal({ ...docInfo, images: [docInfo.back_photo] })}
                                                                                    title="View Back Photo"
                                                                                >
                                                                                    <Icon icon="mdi:eye" width={20} />
                                                                                </button>
                                                                            ) : (
                                                                                <span className="text-muted">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {docInfo.document_status === 0 ? (
                                                                                <span className="badge bg-warning text-dark">Pending</span>
                                                                            ) : docInfo.document_status === 1 ? (
                                                                                <span className="badge bg-warning text-dark">In Review</span>
                                                                            ) : docInfo.document_status === 2 ? (
                                                                                <span className="badge bg-success">Verified</span>
                                                                            ) : docInfo.document_status === 3 ? (
                                                                                <span className="badge bg-danger">Rejected</span>
                                                                            ) : null}
                                                                        </td>
                                                                        <td className="d-flex gap-2 flex-wrap justify-content-center">
                                                                            {(docInfo.front_photo || docInfo.back_photo) && (
                                                                                <button
                                                                                    className="btn btn-sm btn-light"
                                                                                    onClick={() => openModal(docInfo)}
                                                                                    title="View All Photos"
                                                                                >
                                                                                    <Icon icon="mdi:eye" width={20} />
                                                                                </button>
                                                                            )}
                                                                            {isActionAllowed('DocVerifications', 'edit') ? (
                                                                                <button
                                                                                    className="btn btn-sm btn-light text-success"
                                                                                    onClick={() => handleApprove({ ...docInfo, docType })}
                                                                                    title="Approve"
                                                                                >
                                                                                    <Icon icon="mdi:check-circle" width={20} />
                                                                                </button>
                                                                            ) : null}
                                                                            {isActionAllowed('DocVerifications', 'edit') ? (
                                                                                <button
                                                                                    className="btn btn-sm btn-light text-danger"
                                                                                    onClick={() => handleReject({ ...docInfo, docType })}
                                                                                    title="Reject"
                                                                                >
                                                                                    <Icon icon="mdi:close-circle" width={20} />
                                                                                </button>
                                                                            ) : null}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={6} className="text-center text-muted py-3">
                                                                    Documents not found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* <div
                                    className="tab-pane fade show"
                                    id="pills-vehicles"
                                    role="tabpanel"
                                    aria-labelledby="pills-vehicles-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <DriverCarInfoTable
                                                data={data}
                                                handleApproveCarDoc={handleApproveCarDoc}
                                                handleRejectCarDoc={handleRejectCarDoc}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-transactions' ? 'show active' : ''}`}
                                    id="pills-transactions"
                                    role="tabpanel"
                                    aria-labelledby="pills-transactions-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Amount</th>
                                                        <th>Payment Method</th>
                                                        <th>Status</th>
                                                        <th>Date</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transactionLoading ? (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : transactions.length > 0 ? (
                                                        transactions.map((transaction, index) => (
                                                            <tr key={index}>
                                                                <td>{transaction?.plan_id?.title || ""}</td>
                                                                <td>₹ {transaction?.amount || 0}</td>
                                                                <td>{transaction?.payment_method?.toUpperCase() || "-"}</td>
                                                                <td>
                                                                    <span className={`badge ${transaction.status === 'paid' ? 'bg-success' : 'bg-danger'}`}>
                                                                        {transaction.status}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    {dayjs(transaction.payment_date).format('DD-MM-YYYY hh:mm A')}
                                                                </td>
                                                                <td>I</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center text-muted py-3">
                                                                No transactions found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-tickets' ? 'show active' : ''}`}
                                    id="pills-tickets"
                                    role="tabpanel"
                                    aria-labelledby="pills-tickets-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Description</th>
                                                        <th>Status</th>
                                                        <th>Created At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ticketsLoading ? (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : tickets.length > 0 ? (
                                                        tickets.map((ticket, index) => (
                                                            <tr key={index}>
                                                                <td>{ticket.title}</td>
                                                                <td>{ticket.description}</td>
                                                                <td>
                                                                    <span className={`badge ${ticket.status === 'pending' ? 'bg-warning text-dark' :
                                                                        ticket.status === 'inprogress' ? 'bg-info' :
                                                                            ticket.status === 'completed' ? 'bg-success' :
                                                                                'bg-secondary'}`}>
                                                                        {ticket.status}
                                                                    </span>
                                                                </td>
                                                                <td>{dayjs(ticket.createdAt).format('DD-MM-YYYY hh:mm A')}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center text-muted py-3">
                                                                No tickets found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {tickets.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {ticketPage} of {totalTicketPages}</span>
                                                <SmartPagination
                                                    total_pages={totalTicketPages}
                                                    current_page={ticketPage}
                                                    onPageChange={handleTicketPageChange}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* ===== Rides Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-rides' ? 'show active' : ''}`}
                                    id="pills-rides"
                                    role="tabpanel"
                                    aria-labelledby="pills-rides-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Ride Number</th>
                                                        {profile?.user_type === 'superadmin' && (
                                                            <th className="text-center">Name</th>
                                                        )}
                                                        <th className="text-center">Pickup</th>
                                                        <th className="text-center">Drop</th>
                                                        <th className="text-center">Status</th>
                                                        <th className="text-center">Cab Type</th>
                                                        <th className="text-center">Created At</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ridesLoading ? (
                                                        <tr>
                                                            <td colSpan={profile?.user_type === 'superadmin' ? "11" : "7"} className="text-center">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : rides.length > 0 ? (
                                                        rides.map((ride, idx) => (
                                                            <tr key={ride._id || idx}>
                                                                <td className="text-start fw-medium">{ride?.booking_number || '-'}</td>
                                                                {profile?.user_type === 'superadmin' && (
                                                                    <td className="text-center">{ride?.data_type || '-'}</td>
                                                                )}
                                                                <td className="text-center">
                                                                    {ride?.pickup_destination?.city_name
                                                                        ? `${ride.pickup_destination.city_name}, ${ride.pickup_destination.state_name}`
                                                                        : ride?.all_destination?.[0]?.city_name
                                                                            ? `${ride.all_destination[0].city_name}, ${ride.all_destination[0].state_name}`
                                                                            : '-'}
                                                                </td>
                                                                <td className="text-center">
                                                                    {ride?.drop_destination?.city_name
                                                                        ? `${ride.drop_destination.city_name}, ${ride.drop_destination.state_name}`
                                                                        : ride?.all_destination?.[1]?.city_name
                                                                            ? `${ride.all_destination[1].city_name}, ${ride.all_destination[1].state_name}`
                                                                            : '-'}
                                                                </td>
                                                                <td className="text-center">{rideStatusBadge(ride?.booking_status)}</td>
                                                                <td className="text-center">{ride?.cab_type?.name || '-'}</td>
                                                                <td className="text-center">
                                                                    {dayjs(ride?.createdAt).format('DD MMM YYYY hh:mm A')}
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleViewRide(ride)}
                                                                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle mx-auto"
                                                                    >
                                                                        <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={profile?.user_type === 'superadmin' ? "11" : "7"} className="text-center text-muted py-4">No rides found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {rides.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {ridePage} of {totalRidePages}</span>
                                                <SmartPagination
                                                    total_pages={totalRidePages}
                                                    current_page={ridePage}
                                                    onPageChange={(p) => { setRidePage(p); fetchDriverRides(p); }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Rides Tab ===== */}

                                {/* ===== My Rides Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-my-rides' ? 'show active' : ''}`}
                                    id="pills-my-rides"
                                    role="tabpanel"
                                    aria-labelledby="pills-my-rides-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Ride Number</th>
                                                        {profile?.user_type === 'superadmin' && (
                                                            <th className="text-center">Name</th>
                                                        )}
                                                        <th className="text-center">Pickup</th>
                                                        <th className="text-center">Drop</th>
                                                        <th className="text-center">Status</th>
                                                        <th className="text-center">Cab Type</th>
                                                        <th className="text-center">Created At</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {myRidesLoading ? (
                                                        <tr>
                                                            <td colSpan={profile?.user_type === 'superadmin' ? "11" : "7"} className="text-center">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : myRides.length > 0 ? (
                                                        myRides.map((ride, idx) => (
                                                            <tr key={ride._id || idx}>
                                                                <td className="text-start fw-medium">{ride?.booking_number || '-'}</td>
                                                                {profile?.user_type === 'superadmin' && (
                                                                    <td className="text-center">{ride?.data_type || '-'}</td>
                                                                )}
                                                                <td className="text-center">
                                                                    {ride?.pickup_destination?.city_name
                                                                        ? `${ride.pickup_destination.city_name}, ${ride.pickup_destination.state_name}`
                                                                        : ride?.all_destination?.[0]?.city_name
                                                                            ? `${ride.all_destination[0].city_name}, ${ride.all_destination[0].state_name}`
                                                                            : '-'}
                                                                </td>
                                                                <td className="text-center">
                                                                    {ride?.drop_destination?.city_name
                                                                        ? `${ride.drop_destination.city_name}, ${ride.drop_destination.state_name}`
                                                                        : ride?.all_destination?.[1]?.city_name
                                                                            ? `${ride.all_destination[1].city_name}, ${ride.all_destination[1].state_name}`
                                                                            : '-'}
                                                                </td>
                                                                <td className="text-center">{rideStatusBadge(ride?.booking_status)}</td>
                                                                <td className="text-center">{ride?.cab_type?.name || '-'}</td>
                                                                <td className="text-center">
                                                                    {dayjs(ride?.createdAt).format('DD MMM YYYY hh:mm A')}
                                                                </td>
                                                                <td className="text-center">
                                                                    <div className="d-flex justify-content-center gap-2 mx-auto">
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleViewRide(ride)}
                                                                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                        >
                                                                            <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                                        </button>
                                                                        {isActionAllowed('Rides', 'edit') && (
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => handleOpenCancelRide(ride)}
                                                                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                            >
                                                                                <Icon icon="akar-icons:cross" />
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={profile?.user_type === 'superadmin' ? "11" : "7"} className="text-center text-muted py-4">No rides found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {myRides.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {myRidePage} of {totalMyRidePages}</span>
                                                <SmartPagination
                                                    total_pages={totalMyRidePages}
                                                    current_page={myRidePage}
                                                    onPageChange={(p) => { setMyRidePage(p); fetchMyCreatedRides(p); }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /My Rides Tab ===== */}

                                {/* ===== Activity Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-activity' ? 'show active' : ''}`}
                                    id="pills-activity"
                                    role="tabpanel"
                                    aria-labelledby="pills-activity-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        {/* Date range filters */}
                                        <div className="d-flex flex-wrap align-items-center gap-3 mb-20">
                                            <div className="d-flex align-items-center gap-2">
                                                <label className="form-label mb-0 text-sm fw-semibold text-secondary-light text-nowrap">Start Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm w-auto"
                                                    value={activityStartDate}
                                                    onChange={(e) => {
                                                        setActivityStartDate(e.target.value);
                                                        setActivityPage(1);
                                                        fetchActivity(1, e.target.value, activityEndDate);
                                                    }}
                                                />
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <label className="form-label mb-0 text-sm fw-semibold text-secondary-light text-nowrap">End Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm w-auto"
                                                    value={activityEndDate}
                                                    min={activityStartDate || undefined}
                                                    onChange={(e) => {
                                                        setActivityEndDate(e.target.value);
                                                        setActivityPage(1);
                                                        fetchActivity(1, activityStartDate, e.target.value);
                                                    }}
                                                />
                                            </div>
                                            {(activityStartDate || activityEndDate) && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => {
                                                        setActivityStartDate('');
                                                        setActivityEndDate('');
                                                        setActivityPage(1);
                                                        fetchActivity(1, '', '');
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            )}
                                        </div>

                                        {/* Table */}
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Date</th>
                                                        <th className="text-center">Active Count</th>
                                                        <th className="text-center">First Active At</th>
                                                        <th className="text-center">Last Active At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {activityLoading ? (
                                                        <tr>
                                                            <td colSpan="4" className="text-center py-4">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : activityLogs.length > 0 ? (
                                                        activityLogs.map((log, idx) => {
                                                            return (
                                                                <tr key={log._id || idx}>
                                                                    <td className="text-start fw-medium">
                                                                        {log.date ? dayjs(log.date).format('DD MMM YYYY') : '-'}
                                                                    </td>
                                                                    <td className="text-center text-secondary-light">
                                                                        {log.total_active_count || 0}
                                                                    </td>
                                                                    <td className="text-center text-secondary-light">
                                                                        {log.first_active_at ? dayjs(log.first_active_at).format('hh:mm:ss A') : '-'}
                                                                    </td>
                                                                    <td className="text-center text-secondary-light">
                                                                        {log.last_active_at ? dayjs(log.last_active_at).format('hh:mm:ss A') : '-'}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center text-muted py-4">No activity found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        {activityLogs.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {activityPage} of {totalActivityPages}</span>
                                                <SmartPagination
                                                    total_pages={totalActivityPages}
                                                    current_page={activityPage}
                                                    onPageChange={(p) => { setActivityPage(p); fetchActivity(p); }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Activity Tab ===== */}

                                {/* ===== Wallet History Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-wallet' ? 'show active' : ''}`}
                                    id="pills-wallet"
                                    role="tabpanel"
                                    aria-labelledby="pills-wallet-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        {/* Wallet Balance Card */}
                                        <div className="row mb-24">
                                            <div className="">
                                                <div className="card border-0 shadow-sm bg-primary-50">
                                                    <div className="card-body text-center p-20">
                                                        <div className="w-48-px h-48-px bg-primary-100 rounded-circle d-inline-flex align-items-center justify-content-center mb-12">
                                                            <Icon icon="mdi:wallet-outline" className="text-primary-600 text-2xl" />
                                                        </div>
                                                        <p className="text-secondary-light text-sm mb-4 fw-semibold">Current Balance</p>
                                                        <h4 className="mb-0 fw-bold text-primary-600">
                                                            {walletLoading && !walletBalance
                                                                ? '...'
                                                                : `₹${walletBalance?.balance ?? 0}`}
                                                        </h4>
                                                        {walletBalance?.updatedAt && (
                                                            <p className="text-xs text-secondary-light mt-8 mb-0">
                                                                Updated: {dayjs(walletBalance.updatedAt).format('DD MMM YYYY, hh:mm A')}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* History Table */}
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Date</th>
                                                        <th className="text-center">Type</th>
                                                        <th className="text-end">Amount</th>
                                                        <th className="text-start">Title</th>
                                                        <th className="text-start">Description</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {walletLoading ? (
                                                        <tr>
                                                            <td colSpan="5" className="text-center py-4">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : walletHistory.length > 0 ? (
                                                        walletHistory.map((item) => (
                                                            <tr key={item._id}>
                                                                <td className="text-start fw-medium">
                                                                    {dayjs(item.createdAt).format('DD MMM YYYY, hh:mm A')}
                                                                </td>
                                                                <td className="text-center">
                                                                    {item.transaction_type === 'credit' ? (
                                                                        <span className="badge bg-success-focus text-success-600 border border-success-main px-12 py-4 radius-4 fw-medium text-xs">Credit</span>
                                                                    ) : (
                                                                        <span className="badge bg-danger-focus text-danger-600 border border-danger-main px-12 py-4 radius-4 fw-medium text-xs">Debit</span>
                                                                    )}
                                                                </td>
                                                                <td className={`text-end fw-bold ${item.transaction_type === 'credit' ? 'text-success-main' : 'text-danger-main'}`}>
                                                                    {item.transaction_type === 'credit' ? '+' : '-'}₹{item.changed_amount}
                                                                </td>
                                                                <td className="text-start text-secondary-light">
                                                                    {item.title || '-'}
                                                                </td>
                                                                <td className="text-start text-secondary-light">
                                                                    {item.description || '-'}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center text-muted py-4">No wallet history found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        {walletHistory.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {walletPage} of {totalWalletPages}</span>
                                                <SmartPagination
                                                    total_pages={totalWalletPages}
                                                    current_page={walletPage}
                                                    onPageChange={(p) => { setWalletPage(p); fetchWalletHistory(p); }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Wallet History Tab ===== */}

                                {/* ===== Permissions Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-permissions' ? 'show active' : ''}`}
                                    id="pills-permissions"
                                    role="tabpanel"
                                    aria-labelledby="pills-permissions-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        {data?.permissions ? (
                                            <div className="table-responsive scroll-sm">
                                                <table className="table bordered-table sm-table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-start">#</th>
                                                            <th className="text-start">Permission</th>
                                                            <th className="text-center">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(data.permissions).map(([key, value], idx) => {
                                                            const label = key
                                                                .replace(/_/g, ' ')
                                                                .replace(/\b\w/g, c => c.toUpperCase());
                                                            const granted = Boolean(value);
                                                            return (
                                                                <tr key={key}>
                                                                    <td className="text-start fw-medium">{idx + 1}</td>
                                                                    <td className="text-start">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <Icon
                                                                                icon={granted ? 'mdi:check-circle' : 'mdi:close-circle'}
                                                                                className={`text-lg ${granted ? 'text-success-600' : 'text-danger-600'}`}
                                                                            />
                                                                            <span className="fw-medium text-secondary-light">{label}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {granted ? (
                                                                            <span className="badge bg-success-focus text-success-600 border border-success-main px-12 py-4 radius-4 fw-medium text-xs">Granted</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger-focus text-danger-600 border border-danger-main px-12 py-4 radius-4 fw-medium text-xs">Denied</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p className="text-center text-muted py-4 mb-0">No permissions data available</p>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Permissions Tab ===== */}

                                {/* ===== Device Info Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-device' ? 'show active' : ''}`}
                                    id="pills-device"
                                    role="tabpanel"
                                    aria-labelledby="pills-device-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        {data?.device_info ? (
                                            <div className="table-responsive scroll-sm">
                                                <table className="table bordered-table sm-table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-start" style={{ width: '35%' }}>Field</th>
                                                            <th className="text-start">Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(data.device_info)
                                                            .filter(([key]) => !['permission_info', '__v', '_id', 'user_id'].includes(key))
                                                            .map(([key, value]) => {
                                                                const label = key
                                                                    .replace(/_/g, ' ')
                                                                    .replace(/\b\w/g, c => c.toUpperCase());
                                                                let displayValue = value;
                                                                if (key === 'createdAt' || key === 'updatedAt') {
                                                                    displayValue = value ? dayjs(value).format('DD MMM YYYY, hh:mm A') : '-';
                                                                } else if (typeof value === 'string' && value.length > 60) {
                                                                    displayValue = (
                                                                        <span
                                                                            className="d-inline-block text-truncate"
                                                                            style={{ maxWidth: '400px' }}
                                                                            title={value}
                                                                        >
                                                                            {value}
                                                                        </span>
                                                                    );
                                                                } else if (value === null || value === undefined || value === '') {
                                                                    displayValue = '-';
                                                                }
                                                                return (
                                                                    <tr key={key}>
                                                                        <td className="text-start fw-semibold text-primary-light">{label}</td>
                                                                        <td className="text-start text-secondary-light">{displayValue}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p className="text-center text-muted py-4 mb-0">No device info available</p>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Device Info Tab ===== */}

                                {/* ===== Ride Call Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-ridecall' ? 'show active' : ''}`}
                                    id="pills-ridecall"
                                    role="tabpanel"
                                    aria-labelledby="pills-ridecall-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Ride No</th>
                                                        <th className="text-start">Name</th>
                                                        <th className="text-center">Pickup</th>
                                                        <th className="text-center">Drop</th>
                                                        <th className="text-center">Status</th>
                                                        <th className="text-center">Cab Type</th>
                                                        <th className="text-center">Created At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rideCallLoading ? (
                                                        <tr>
                                                            <td colSpan="7" className="text-center py-4">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : rideCalls.length > 0 ? (
                                                        rideCalls.map((item) => (
                                                            <tr key={item._id}>
                                                                <td className="text-start fw-medium">{item.booking_number || '-'}</td>
                                                                <td className="text-start text-secondary-light">{item.data_type || '-'}</td>
                                                                <td className="text-center text-secondary-light">
                                                                    {item.pickup_destination ? `${item.pickup_destination.city_name}, ${item.pickup_destination.state_name}` : '-'}
                                                                </td>
                                                                <td className="text-center text-secondary-light">
                                                                    {item.drop_destination ? `${item.drop_destination.city_name}, ${item.drop_destination.state_name}` : '-'}
                                                                </td>
                                                                <td className="text-center">{rideStatusBadge(item.booking_status)}</td>
                                                                <td className="text-center text-secondary-light">{item.cab_type?.name || '-'}</td>
                                                                <td className="text-center text-secondary-light">
                                                                    {dayjs(item.createdAt).format('DD MMM YYYY, hh:mm A')}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center text-muted py-4">No ride call history found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        {rideCalls.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {rideCallPage} of {totalRideCallPages}</span>
                                                <SmartPagination
                                                    total_pages={totalRideCallPages}
                                                    current_page={rideCallPage}
                                                    onPageChange={(p) => { setRideCallPage(p); fetchRideCallHistory(p); }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Ride Call Tab ===== */}

                                {/* ===== Call History Tab ===== */}
                                <div
                                    className={`tab-pane fade ${activeTab === 'pills-callhistory' ? 'show active' : ''}`}
                                    id="pills-callhistory"
                                    role="tabpanel"
                                    aria-labelledby="pills-callhistory-tab"
                                    tabIndex={0}
                                >
                                    <div className="card-body">
                                        <div className="table-responsive scroll-sm">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start">Admin</th>
                                                        <th className="text-center">Duration</th>
                                                        <th className="text-center">Start Time</th>
                                                        <th className="text-center">End Time</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {callHistoryLoading ? (
                                                        <tr>
                                                            <td colSpan="5" className="text-center py-4">
                                                                <CommonLoader />
                                                            </td>
                                                        </tr>
                                                    ) : callHistory.length > 0 ? (
                                                        callHistory.map((item) => {
                                                            const durationMin = Math.floor((item.duration || 0) / 60);
                                                            const durationSec = (item.duration || 0) % 60;
                                                            return (
                                                                <tr key={item._id}>
                                                                    <td className="text-start text-secondary-light">
                                                                        {item.admin_id?.user_name || item.admin_id?.email || '-'}
                                                                    </td>
                                                                    <td className="text-center text-secondary-light">
                                                                        {item.duration > 0
                                                                            ? `${durationMin}m ${durationSec}s`
                                                                            : '-'}
                                                                    </td>
                                                                    <td className="text-center text-secondary-light">
                                                                        {dayjs(item.createdAt).format('DD MMM YYYY, hh:mm A')}
                                                                    </td>
                                                                    <td className="text-center text-secondary-light">
                                                                        {item.updatedAt ? dayjs(item.updatedAt).format('DD MMM YYYY, hh:mm A') : '-'}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {item.recording_url ? (
                                                                            <button
                                                                                type="button"
                                                                                className="bg-info-focus bg-hover-info-200 text-info-600 w-32-px h-32-px d-inline-flex justify-content-center align-items-center rounded-circle border-0"
                                                                                onClick={() => handlePlayAudio(item.recording_url)}
                                                                                title={playingUrl === item.recording_url && !isAudioPaused ? 'Pause Recording' : 'Play Recording'}
                                                                            >
                                                                                <Icon
                                                                                    icon={playingUrl === item.recording_url && !isAudioPaused ? 'mdi:pause-circle-outline' : 'mdi:play-circle-outline'}
                                                                                    className="text-xl"
                                                                                />
                                                                            </button>
                                                                        ) : (
                                                                            <span className="text-muted">-</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center text-muted py-4">No call history found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        {callHistory.length > 0 && (
                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                                <span>Page {callHistoryPage} of {totalCallHistoryPages}</span>
                                                <SmartPagination
                                                    total_pages={totalCallHistoryPages}
                                                    current_page={callHistoryPage}
                                                    onPageChange={(p) => { setCallHistoryPage(p); fetchCallHistory(p); }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* ===== /Call History Tab ===== */}

                            </div>
                        </div>
                    </div>
                </div>
            </div >
        }

        {/* ===== Ride Detail Dialog ===== */}
        <Dialog
            open={openRideView}
            onClose={() => setOpenRideView(false)}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderRadius: '16px', backgroundColor: 'transparent', boxShadow: 'none' },
            }}
        >
            <div className="card shadow-none mb-0 border-0">
                <div className="card-header d-flex justify-content-between align-items-center border-bottom bg-base">
                    <h6 className="card-title mb-0">Ride Details</h6>
                    <button
                        type="button"
                        className="btn btn-sm btn-light-focus p-1 d-flex justify-content-center align-items-center radius-8"
                        onClick={() => setOpenRideView(false)}
                    >
                        <MdClose size={18} />
                    </button>
                </div>
                {rideDetailLoading ? (
                    <div className="card-body bg-base"><CommonLoader /></div>
                ) : (
                    <div className="card-body p-24 bg-base">
                        <div className="row g-4">
                            {/* Header: Booking number + status */}
                            <div className="col-12">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 p-20 bg-neutral-50 radius-12 border border-neutral-100">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="w-48-px h-48-px bg-primary-50 rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="solar:hashtag-square-outline" className="text-primary-600 text-2xl" />
                                        </div>
                                        <div>
                                            <h6 className="mb-0 fw-bold">#{selectedRideDetail?.booking_number}</h6>
                                            <span className="text-secondary-light text-sm">Ride Booking Number</span>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-4">
                                        <div className="text-end">
                                            <div className="text-secondary-light text-xs mb-1 fw-bold">BOOKING STATUS</div>
                                            {rideStatusBadge(selectedRideDetail?.booking_status)}
                                        </div>
                                        <div className="border-start border-neutral-200 ps-4">
                                            <div className="text-secondary-light text-xs mb-1 fw-bold">RIDE DATE</div>
                                            <div className="fw-semibold text-md">
                                                {dayjs(selectedRideDetail?.dueDate || selectedRideDetail?.createdAt).format('DD MMM, YYYY')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Route information */}
                            <div className="col-lg-7">
                                <div className="card h-100 border border-neutral-100 shadow-none radius-12">
                                    <div className="card-header border-bottom py-12 px-20">
                                        <h6 className="text-md fw-bold mb-0 d-flex align-items-center gap-2">
                                            <Icon icon="solar:map-point-wave-outline" className="text-primary-600" />
                                            Route Information
                                        </h6>
                                    </div>
                                    <div className="card-body p-20">
                                        <div className="table-responsive">
                                            <table className="table bordered-table sm-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary-light fw-bold text-xs py-2 px-3 border-bottom bg-neutral-50">CITY</th>
                                                        <th className="text-secondary-light fw-bold text-xs py-2 px-3 text-end border-bottom bg-neutral-50">STATE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(selectedRideDetail?.destination_docs || selectedRideDetail?.all_destination)?.map((item, idx, arr) => (
                                                        <tr key={idx}>
                                                            <td className="py-3 px-3">
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <div className={`w-10-px h-10-px rounded-circle ${idx === 0 ? 'bg-success-main' : idx === (arr.length - 1) ? 'bg-danger-main' : 'bg-warning-main'}`} />
                                                                    <span className="fw-medium text-secondary-light">{item?.city_name || 'N/A'}</span>
                                                                </div>
                                                            </td>
                                                            <td className="py-3 px-3 text-end text-secondary-light">{item?.state_name || 'N/A'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {selectedRideDetail?.note && (
                                            <div className="mt-20 p-16 bg-warning-50 radius-8 border border-warning-200">
                                                <div className="text-xs fw-bold text-warning-main mb-8 d-flex align-items-center gap-2">
                                                    <Icon icon="solar:info-circle-outline" className="text-lg" /> RIDE NOTE
                                                </div>
                                                <p className="mb-0 text-sm text-secondary-light">{selectedRideDetail?.note}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Agent + Vehicle */}
                            <div className="col-lg-5">
                                <div className="row g-3 h-100">
                                    <div className="col-12">
                                        <div className="card border border-neutral-100 shadow-none radius-12 bg-base">
                                            <div className="card-header border-bottom py-12 px-20">
                                                <h6 className="text-md fw-bold mb-0 d-flex align-items-center gap-2">
                                                    <Icon icon="solar:user-speak-outline" className="text-primary-600" />
                                                    Agent Details
                                                </h6>
                                            </div>
                                            <div className="card-body p-20">
                                                <div className="d-flex align-items-center gap-3 mb-20">
                                                    <Avatar src={selectedRideDetail?.agent_id?.profile_photo} sx={{ width: 56, height: 56, border: '2px solid #6b728033' }} />
                                                    <div>
                                                        <h6 className="mb-4 fw-bold text-secondary-light">{selectedRideDetail?.agent_id?.user_name || '-'}</h6>
                                                        <div className="text-neutral-500 text-sm">{selectedRideDetail?.agent_id?.email || '-'}</div>
                                                    </div>
                                                </div>
                                                <div className="p-16 bg-neutral-50 radius-8 border border-neutral-100 d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <div className="text-xs text-neutral-500 mb-4 fw-bold">CONTACT NUMBER</div>
                                                        <div className="fw-bold text-secondary-light">{selectedRideDetail?.agent_id?.phone_number || '-'}</div>
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            onClick={() => handleWhatsAppClick(selectedRideDetail?.agent_id?.phone_number, selectedRideDetail?.agent_id?.user_name)}
                                                            className="bg-info-100 text-info-600 hover-bg-info-200 transition-all w-44-px h-44-px d-flex justify-content-center align-items-center rounded-circle border-0"
                                                        >
                                                            <Icon icon="ic:baseline-whatsapp" className="text-xl" />
                                                        </button>
                                                        <button
                                                            onClick={() => showPhone(selectedRideDetail?.agent_id?.phone_number, selectedRideDetail?.agent_id?.user_name)}
                                                            className="bg-warning-100 text-warning-main hover-bg-warning-200 transition-all w-44-px h-44-px d-flex justify-content-center align-items-center rounded-circle border-0"
                                                        >
                                                            <Icon icon="akar-icons:phone" className="text-xl" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="p-16 bg-neutral-50 radius-8 d-flex align-items-center justify-content-between border border-neutral-100 mt-1">
                                                    <div>
                                                        <div className="text-xs text-neutral-500 mb-4 fw-bold uppercase">Customer Number</div>
                                                        <div className="fw-bold text-secondary-light">{selectedRideDetail?.phone_number}</div>
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            onClick={() => handleWhatsAppClick(selectedRideDetail?.phone_number, "")}
                                                            className="bg-info-100 text-info-600 hover-bg-info-200 transition-all w-44-px h-44-px d-flex justify-content-center align-items-center rounded-circle border-0"
                                                        >
                                                            <Icon icon="ic:baseline-whatsapp" className="text-xl" />
                                                        </button>
                                                        <button
                                                            onClick={() => showPhone(selectedRideDetail?.phone_number, "")}
                                                            className="bg-warning-100 text-warning-main hover-bg-warning-200 transition-all w-44-px h-44-px d-flex justify-content-center align-items-center rounded-circle border-0"
                                                        >
                                                            <Icon icon="akar-icons:phone" className="text-xl" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="card border border-neutral-100 shadow-none radius-12 bg-base">
                                            <div className="card-header border-bottom py-12 px-20">
                                                <h6 className="text-md fw-bold mb-0 d-flex align-items-center gap-2">
                                                    <Icon icon="solar:bus-outline" className="text-primary-600" />
                                                    Vehicle Info
                                                </h6>
                                            </div>
                                            <div className="card-body p-20">
                                                <div className="d-flex align-items-center gap-4">
                                                    {selectedRideDetail?.cab_type?.vehicle_img && (
                                                        <div className="bg-neutral-50 p-12 radius-12 border border-neutral-100">
                                                            <img src={selectedRideDetail?.cab_type?.vehicle_img} alt="Cab" style={{ height: '60px', objectFit: 'contain' }} />
                                                        </div>
                                                    )}
                                                    <div>
                                                        <div className="text-xs text-neutral-500 mb-4 fw-bold">SELECTED CAB TYPE</div>
                                                        <h6 className="mb-0 fw-bold text-primary-600 text-lg">{selectedRideDetail?.cab_type?.name || '-'}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
        {/* ===== /Ride Detail Dialog ===== */}

        <Dialog
            open={modalOpen}
            onClose={closeModal}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Document Details</h6>
                    <button type="button" className="btn btn-sm btn-light p-1" onClick={closeModal}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                        <span>
                            Document No. {selectedDoc.number || selectedDoc?.details || '-'}
                        </span>
                        {selectedDoc.document_status === 0 ? (
                            <span className="badge bg-white text-dark">Pending</span>
                        ) : selectedDoc.document_status === 1 ? (
                            <span className="badge bg-warning text-dark">In Review</span>
                        ) : selectedDoc.document_status === 2 ? (
                            <span className="badge bg-success">Verified</span>
                        ) : selectedDoc.document_status === 3 ? (
                            <span className="badge bg-danger">Rejected</span>
                        ) : null}
                    </div>

                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                        className="main-swiper mt-3"
                        ref={mainSwiperRef}
                    >
                        {selectedDoc?.images?.map((imgUrl, index) => (
                            <SwiperSlide key={index}>
                                <PhotoProvider>
                                    <PhotoView src={imgUrl}>
                                        <img
                                            src={imgUrl}
                                            alt={`Image ${index + 1}`}
                                            className="w-100"
                                            style={{ objectFit: 'contain', height: '400px' }}
                                        />
                                    </PhotoView>
                                </PhotoProvider>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div
                        className="thumbnail-container"
                        style={{
                            display: 'flex',
                            overflowX: 'auto',
                            padding: '10px 0',
                            gap: '10px',
                        }}
                    >
                        {selectedDoc?.images?.map((imgUrl, index) => (
                            <div
                                key={index}
                                className="thumbnail-item"
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    cursor: 'pointer',
                                    border: activeIndex === index ? '2px solid #007bff' : 'none',
                                    borderRadius: "10px"
                                }}
                                onClick={() => handleThumbnailClick(index)}
                            >
                                <img
                                    src={imgUrl}
                                    alt={`Thumbnail ${index + 1}`}
                                    style={{
                                        objectFit: 'cover',
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '10px',
                                        padding: activeIndex === index ? '1px' : '',
                                        transition: 'filter 0.3s ease',
                                    }}
                                />

                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Dialog>


        <Dialog
            open={openApprove}
            onClose={() => setOpenApprove(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Approve Document</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setOpenApprove(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <p className="text-center">
                        Are you sure want to approve this document ?
                    </p>
                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <button onClick={handleApproveSubmit}
                            className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8">
                            Approve
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>


        <Dialog
            open={openApproveCarDoc}
            onClose={() => setOpenApproveCarDoc(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Approve Car Document</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setOpenApproveCarDoc(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <p className="text-center">
                        Are you sure want to approve this document ?
                    </p>
                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <button onClick={handleApproveSubmitCarDoc}
                            className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8">
                            Approve
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog
            open={openReject}
            onClose={() => setOpenReject(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Reject Document</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setOpenReject(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <p className="">

                        <textarea
                            className="form-control"
                            rows="4"
                            placeholder="Write reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </p>
                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <button onClick={handleRejectSubmit} className="btn btn-danger border border-danger-600 text-md px-48 py-12 radius-8">
                            Reject
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog
            open={openRejectCarDoc}
            onClose={() => setOpenRejectCarDoc(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Reject Car Document</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setOpenRejectCarDoc(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <p className="">

                        <textarea
                            className="form-control"
                            rows="4"
                            placeholder="Write reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </p>
                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <button onClick={handleRejectSubmitCarDoc} className="btn btn-danger border border-danger-600 text-md px-48 py-12 radius-8">
                            Reject
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog
            open={statusModal}
            onClose={() => setStatusModal(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Confirmation</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setStatusModal(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <div className="text-center py-16">
                        <div className="icon-box bg-primary-50 text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center mb-16" style={{ width: '64px', height: '64px' }}>
                            <Icon icon="mdi:information-outline" width={32} />
                        </div>
                        <h6 className="text-lg fw-bold mb-8">Confirm Status Change</h6>
                        <p className="text-secondary-light mx-auto" style={{ maxWidth: '300px' }}>
                            Are you sure you want to toggle the <strong>{statusField === "account_status" ? "Account Status" : "Duty Status"}</strong>? This action will take effect immediately.
                        </p>
                    </div>

                    <div className="d-flex justify-content-center align-items-center gap-3 mt-24">
                        <button
                            type="button"
                            className="btn btn-outline-secondary text-md px-32 py-12 radius-8 w-50"
                            onClick={() => setStatusModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleToggleStatus}
                            disabled={statusLoading}
                            className="btn btn-primary text-md px-32 py-12 radius-8 w-50 d-flex align-items-center justify-content-center gap-2"
                        >
                            {statusLoading ? "Updating..." : "Confirm Change"}
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog
            open={buyPlanModal}
            onClose={() => setBuyPlanModal(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Buy Subscription Plan</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setBuyPlanModal(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <div className="mb-24">
                        <label className="form-label fw-semibold text-primary-light mb-16">Select Subscription Plan</label>
                        <div className="row gy-3">
                            {plans.map((plan) => (
                                <div className="col-md-4" key={plan._id}>
                                    <div
                                        className={`p-16 radius-12 border cursor-pointer h-100 transition-all ${selectedPlan === plan._id
                                            ? "border-primary-600 bg-primary-50"
                                            : "border-neutral-200 hover-border-primary-400"
                                            }`}
                                        onClick={() => setSelectedPlan(plan._id)}
                                        style={{
                                            position: 'relative',
                                            backgroundColor: selectedPlan === plan._id ? 'rgba(var(--primary-rgb), 0.1)' : 'transparent'
                                        }}
                                    >
                                        {selectedPlan === plan._id && (
                                            <div
                                                className="position-absolute end-0 top-0 mt-8 me-8 bg-primary-600 text-white rounded-circle d-flex align-items-center justify-content-center"
                                                style={{ width: '20px', height: '20px' }}
                                            >
                                                <Icon icon="mdi:check" width={14} />
                                            </div>
                                        )}
                                        <h6 className={`text-md mb-4 ${selectedPlan === plan._id ? "text-primary-600" : "text-primary-light"}`}>
                                            {plan.title}
                                        </h6>
                                        <div className="d-flex align-items-baseline gap-1 mb-8">
                                            <span className="text-xl fw-bold">₹{plan.selling_price}</span>
                                            <span className="text-xs text-secondary-light">/{plan.duration_in_days} Days</span>
                                        </div>
                                        {plan.description && (
                                            <p className="text-xs text-secondary-light mb-0 line-clamp-2">
                                                {plan.description}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <button
                            onClick={handleBuyPlan}
                            disabled={plansLoading || !selectedPlan}
                            className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8 w-100 d-flex align-items-center justify-content-center gap-2"
                        >
                            {plansLoading ? <PremiumLoader size="small" color="white" /> : "Assign Selected Plan"}
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog
            open={addCityModal}
            onClose={() => setAddCityModal(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Add New City</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setAddCityModal(false)}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <div className="mb-20">
                        <label className="form-label fw-semibold text-primary-light mb-8">Search City</label>
                        <div className="input-group">
                            <span className="input-group-text bg-base text-secondary-light border-end-0">
                                <Icon icon="mdi:magnify" width={20} />
                            </span>
                            <input
                                type="text"
                                className="form-control border-start-0 ps-0"
                                placeholder="Start typing city name..."
                                value={citySearchQuery}
                                onChange={(e) => setCitySearchQuery(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="city-results-list" style={{ maxHeight: '380px', overflowY: 'auto' }}>
                        {placesLoading && citySearchPage === 1 ? (
                            <div className="d-flex justify-content-center py-20">
                                <PremiumLoader size="small" />
                            </div>
                        ) : citySearchResults.length > 0 ? (
                            <>
                                {citySearchResults.map((city) => (
                                    <div
                                        key={city._id}
                                        className="p-12 radius-8 border mb-8 cursor-pointer hover-bg-primary-50 transition-all border-neutral-200"
                                        onClick={() => {
                                            setSelectedCityToAdd(city);
                                            setAddCityConfirmModal(true);
                                        }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="text-md mb-4">{city.city_name}</h6>
                                                <p className="text-xs text-secondary-light mb-0">{city.state_name}, {city.country_name}</p>
                                            </div>
                                            <Icon icon="mdi:plus-circle-outline" width={20} className="text-primary-600" />
                                        </div>
                                    </div>
                                ))}
                                {citySearchPage < totalCitySearchPages && (
                                    <div className="mt-16 text-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm px-24 radius-8 d-flex align-items-center justify-content-center gap-2 mx-auto"
                                            onClick={() => handleSearchCities(citySearchQuery, citySearchPage + 1)}
                                            disabled={placesLoading}
                                        >
                                            {placesLoading ? <PremiumLoader size="small" /> : "Load More"}
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : citySearchQuery ? (
                            <p className="text-center text-muted py-20">No cities found.</p>
                        ) : (
                            <p className="text-center text-muted py-20">Type to search for a city.</p>
                        )}
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog
            open={addCityConfirmModal}
            onClose={() => setAddCityConfirmModal(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Confirm Add</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setAddCityConfirmModal(false)}>
                        <MdClose size={18} />
                    </button>
                </div>
                <div className="card-body">
                    <div className="text-center py-8">
                        <div className="icon-box bg-primary-50 text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center mb-16" style={{ width: '48px', height: '48px' }}>
                            <Icon icon="mdi:city-variant-outline" width={24} />
                        </div>
                        <h6 className="text-md fw-bold mb-8">Add this city?</h6>
                        <p className="text-secondary-light text-sm mb-0">
                            <strong>{selectedCityToAdd?.city_name}</strong> will be added to the selected cities list.
                        </p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-24">
                        <button className="btn btn-outline-secondary btn-sm w-50 radius-8" onClick={() => setAddCityConfirmModal(false)}>Cancel</button>
                        <button className="btn btn-primary btn-sm w-50 radius-8" onClick={handleAddCity}>Add City</button>
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog
            open={deleteCityConfirmModal}
            onClose={() => setDeleteCityConfirmModal(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center bg-danger-50 border-danger-100">
                    <h6 className="card-title mb-0 text-danger-600">Remove City</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={() => setDeleteCityConfirmModal(false)}>
                        <MdClose size={18} />
                    </button>
                </div>
                <div className="card-body">
                    <div className="text-center py-8">
                        <div className="icon-box bg-danger-50 text-danger-600 rounded-circle d-inline-flex align-items-center justify-content-center mb-16" style={{ width: '48px', height: '48px' }}>
                            <Icon icon="mdi:alert-circle-outline" width={24} />
                        </div>
                        <h6 className="text-md fw-bold mb-8">Remove this city?</h6>
                        <p className="text-secondary-light text-sm mb-0">
                            Are you sure you want to remove <strong>{cityToDelete?.city_name}</strong>?
                        </p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-24">
                        <button className="btn btn-outline-secondary btn-sm w-50 radius-8" onClick={() => setDeleteCityConfirmModal(false)}>Cancel</button>
                        <button
                            className="btn btn-danger btn-sm w-50 radius-8 d-flex align-items-center justify-content-center gap-2"
                            onClick={handleDeleteCity}
                            disabled={cityDeleting}
                        >
                            {cityDeleting ? <PremiumLoader size="small" color="white" /> : "Remove"}
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>

        <AddTicketDialog open={addTicketForm} onClose={() => setAddTicketForm(false)} handleAddTicket={handleAddTicket} loading={ticketLoading} />

        <Dialog
            open={showAdminModal}
            onClose={() => setShowAdminModal(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Change Admin</h6>
                    <button
                        type="button"
                        className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center"
                        onClick={() => setShowAdminModal(false)}
                    >
                        <MdClose size={18} />
                    </button>
                </div>
                <div className="card-body">
                    <div className="mb-3">
                        <label className="form-label fw-bold text-sm mb-1">Select Admin (Parent User)</label>
                        <select
                            className="form-select"
                            value={selectedAdminId}
                            onChange={(e) => setSelectedAdminId(e.target.value)}
                        >
                            <option value="">Select Admin</option>
                            {allAdmins.map((admin) => (
                                <option key={admin._id} value={admin._id}>
                                    {admin.user_name} ({admin.parent_user_id?.user_name ? `under ${admin.parent_user_id.user_name}` : admin.email})
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                        <button
                            className="btn btn-primary px-6 py-4 radius-8 text-md"
                            onClick={handleChangeAdmin}
                            disabled={updatingAdmin}
                        >
                            {updatingAdmin ? "Updating..." : "Update Admin"}
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>

        {/* Call Confirmation Dialog */}
        <CallConfirmationDialog
            open={callDialogOpen}
            onClose={() => { setCallDialogOpen(false); setSelectedPhoneNumber(''); setSelectedUserName(''); }}
            onConfirm={handleCallConfirm}
            userName={selectedUserName || data?.user_name}
            phoneNumber={selectedPhoneNumber || data?.phone_number}
            loading={callLoading}
        />

        <WhatsAppConfirmationDialog
            open={whatsappDialogOpen}
            onClose={() => { setWhatsappDialogOpen(false); setSelectedPhoneNumber(''); setSelectedUserName(''); }}
            onConfirm={handleWhatsAppConfirm}
            userName={selectedUserName || data?.user_name}
            phoneNumber={selectedPhoneNumber || data?.phone_number}
            loading={whatsappLoading}
        />

        <Dialog
            open={openCancelRide}
            onClose={() => setOpenCancelRide(false)}
            maxWidth={false}
            fullWidth={false}
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    width: '500px',
                }
            }}
        >
            <form className="card mb-0" onSubmit={(e) => handleCancelRide(e)}>
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Cancel Ride (#{selectedRideToCancel?.booking_number})</h6>
                    <button
                        type="button"
                        className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center"
                        onClick={() => setOpenCancelRide(false)}
                    >
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">
                    <div className="mb-3">
                        <label className="form-label fw-bold text-sm mb-1">Reason</label>
                        <textarea
                            required
                            className="form-control"
                            rows="4"
                            placeholder="Write reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-danger px-8 py-4 radius-8" type="submit" disabled={ridesApiLoading}>
                            {ridesApiLoading ? (
                                <span className="spinner-border spinner-border-sm" />
                            ) : (
                                "Cancel Ride"
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </Dialog>
    </>
    );
};

export default ViewUserProfile;
